import { z } from "zod";

/** Paket ölçüsü: saat kutusu için varsayılan 1 desi, 1 kg, 1 koli. */
const desi = z.coerce.number({ error: "Desi girin" }).min(0.1, { error: "En az 0,1" }).max(500, { error: "En çok 500" });
const kg = z.coerce.number({ error: "Kilo girin" }).min(0.1, { error: "En az 0,1" }).max(500, { error: "En çok 500" });

/**
 * Yurtiçi Kargo web servis bilgileri (Yurtiçi anlaşmayla verir). Gönderici ödemeli hesap zorunlu; kapıda ödeme
 * (tahsilatlı) için Yurtiçi ayrı kullanıcı verir, isteğe bağlıdır. Şifre boş bırakılırsa kayıtlı olan korunur.
 */
export const yurticiConnectSchema = z.object({
  environment: z.enum(["prod", "test"]),
  username: z.string().trim().min(2, { error: "Kullanıcı adı gerekli" }).max(100),
  password: z.string().trim().max(200).optional(),
  codUsername: z.string().trim().max(100).optional(),
  codPassword: z.string().trim().max(200).optional(),
  desi,
  kg,
});
export type YurticiConnectInput = z.input<typeof yurticiConnectSchema>;

/** Kargola: paket ölçüsü (varsayılanlar ayardan), koli sayısı, kapıda ödeme ve kargo notu. */
export const yurticiShipSchema = z.object({
  desi,
  kg,
  cargoCount: z.coerce.number().int().min(1, { error: "En az 1 koli" }).max(20, { error: "En çok 20 koli" }),
  cod: z.boolean().default(false),
  description: z.string().trim().max(200).optional(),
});
export type YurticiShipInput = z.input<typeof yurticiShipSchema>;

export interface YurticiStatusDto {
  connected: boolean;
  environment: "prod" | "test" | null;
  usernameHint: string | null;
  codConfigured: boolean;
  defaults: { desi: number; kg: number };
  connectedAt: string | null;
  lastCheckedAt: string | null;
  lastError: string | null;
  /** Takipteki (teslim edilmemiş, iptal edilmemiş) Yurtiçi gönderisi sayısı. */
  activeShipments: number;
  canManage: boolean;
}

/** Yurtiçi'ye verilecek ağ bilgileri: sunucunun çıkış IP'si (web servis erişim izni için) ve servis adresleri. */
export interface YurticiNetworkDto {
  /** Sunucunun internete çıkarken görünen IP adresi; öğrenilemezse null. */
  outboundIp: string | null;
  /** Sistemin (panelin) kendi alan adı ve adresi. */
  siteHost: string;
  siteUrl: string;
  host: string;
  path: string;
  prodUrl: string;
  testUrl: string;
}

/** Yurtiçi gönderi durumunun panel etiketi. */
export const YURTICI_STATE_LABELS: Record<string, string> = {
  NOP: "Şubeye teslim bekleniyor",
  ISR: "Yurtiçi teslim aldı",
  IND: "Yolda / dağıtımda",
  DLV: "Teslim edildi",
  CNL: "İptal edildi",
  ISC: "İptal edildi",
  BI: "Fatura iptal",
};
